"use strict";

exports.__esModule = true;
exports.default = void 0;

var _v = _interopRequireDefault(require("uuid/v4"));

var _francis = _interopRequireDefault(require("../../francis"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var ROUTES = {
  LOGIN_LOCAL: '/auth/login',
  LOGOUT: '/auth/logout',
  TOKEN: '/auth/token',
  POST_USER: '/auth/user',
  SEND_PASSWORD_RESET: '/auth/send-reset',
  RESET_PASSWORD: '/auth/reset',
  SEND_VERIFICATION_CODE: '/auth/verification/2fa/send',
  CHECK_VERIFICATION_CODE: '/auth/verification/2fa/verify',
  GET_GOOGLE_ACCESS_TOKEN: '/auth/tokens/google/access'
};

var Auth = /*#__PURE__*/function () {
  function Auth(_ref) {
    var _ref$baseURL = _ref.baseURL,
        baseURL = _ref$baseURL === void 0 ? 'http://localhost:8081' : _ref$baseURL,
        _ref$storagePrefix = _ref.storagePrefix,
        storagePrefix = _ref$storagePrefix === void 0 ? 'alphakit_' : _ref$storagePrefix;
    this.config = {
      baseURL: baseURL,
      storagePrefix: storagePrefix
    };

    _francis.default.setStatusCallback(401, this.unauthedCallback.bind(this));

    _francis.default.setAuthToken(this.accessToken);
  }

  var _proto = Auth.prototype;

  _proto._generateClientId = function _generateClientId() {
    return (0, _v.default)();
  };

  _proto.signInLocal = function signInLocal(username, password) {
    var _this = this;

    var data = {
      username: username,
      password: password
    };
    var options = {
      params: {
        clientId: this.clientId
      }
    };
    return _francis.default.post("" + this.config.baseURL + ROUTES.LOGIN_LOCAL, data, options).then(function (res) {
      var _res$data = res.data,
          user = _res$data.user,
          accessToken = _res$data.accessToken,
          refreshToken = _res$data.refreshToken;
      _this.accessToken = accessToken;
      _this.refreshToken = refreshToken;
      _this.userId = user.id;
      var needsVerification = false;

      if (!accessToken) {
        needsVerification = true;
      }

      return Promise.resolve({
        needsVerification: needsVerification,
        user: user,
        accessToken: accessToken,
        refreshToken: refreshToken
      });
    }).catch(function (err) {
      return Promise.reject(err);
    });
  };

  _proto.signOut = function signOut() {
    var options = {
      params: {
        cid: this.clientId,
        refreshToken: this.refreshToken,
        userId: this.userId
      }
    };
    this.accessToken = '';
    this.refreshToken = '';

    _francis.default.setAuthToken(null);

    return _francis.default.get("" + this.config.baseURL + ROUTES.LOGOUT, options);
  };

  _proto.refresh = function refresh() {
    var _this2 = this;

    var options = {
      params: {
        cid: this.clientId,
        refreshToken: this.refreshToken,
        userId: this.userId
      }
    };
    return _francis.default.get("" + this.config.baseURL + ROUTES.TOKEN, options).then(function (res) {
      var accessToken = res.data.accessToken;
      _this2.accessToken = accessToken;
      return Promise.resolve(accessToken);
    }).catch(function (err) {
      return Promise.reject(err);
    });
  };

  _proto.postUser = function postUser(username, password, user_, key) {
    var URL = "" + this.config.baseURL + ROUTES.POST_USER + "?clientId=" + this.clientId;
    var data = {
      username: username,
      password: password,
      user: user_,
      key: key
    };
    return _francis.default.post(URL, data).then(function (res) {
      var user = res.data.user;
      return Promise.resolve(user);
    }).catch(function (err) {
      return Promise.reject(err);
    });
  };

  _proto.unauthedCallback = function unauthedCallback(req, res) {
    var _this3 = this;

    if (res.config.retried) {
      this.signOut();
      return;
    }

    return this.refresh().then(function (accessToken) {
      var config = res.config;
      config.headers.Authorization = "Bearer " + accessToken;
      config.retried = true;
      return _francis.default.request(config);
    }).catch(function (err) {
      _this3.signOut();

      return Promise.reject(err);
    });
  };

  _proto.sendResetEmail = function sendResetEmail(email) {
    var URL = "" + this.config.baseURL + ROUTES.SEND_PASSWORD_RESET;
    var options = {
      params: {
        email: email
      }
    };
    return _francis.default.get(URL, options);
  };

  _proto.resetPassword = function resetPassword(identifier, password, code) {
    var URL = "" + this.config.baseURL + ROUTES.RESET_PASSWORD;
    var data = {
      identifier: identifier,
      password: password,
      code: code
    };
    return _francis.default.post(URL, data);
  };

  _proto.sendVericationCode = function sendVericationCode(userId, deliveryMethod, deliveryValue) {
    var URL = "" + this.config.baseURL + ROUTES.SEND_VERIFICATION_CODE;
    var body = {
      userId: userId,
      deliveryMethod: deliveryMethod,
      deliveryValue: deliveryValue
    };
    return _francis.default.post(URL, body);
  };
  /* eslint-disable camelcase */


  _proto.checkVerificationCode = function checkVerificationCode(user_id, delivery_method, delivery_value, code) {
    var _this4 = this;

    var URL = "" + this.config.baseURL + ROUTES.CHECK_VERIFICATION_CODE + "?clientId=" + this.clientId;
    var options = {
      params: {
        user_id: user_id,
        delivery_method: delivery_method,
        delivery_value: delivery_value,
        code: code
      }
    };
    return _francis.default.get(URL, options).then(function (res) {
      var _res$data2 = res.data,
          accessToken = _res$data2.accessToken,
          refreshToken = _res$data2.refreshToken;
      _this4.accessToken = accessToken;
      _this4.refreshToken = refreshToken;
      return Promise.resolve({
        accessToken: accessToken,
        refreshToken: refreshToken
      });
    }).catch(function (err) {
      return Promise.reject(err);
    });
  };

  _proto.getGoogleAccessToken = function getGoogleAccessToken() {
    var url = "" + this.config.baseURL + ROUTES.GET_GOOGLE_ACCESS_TOKEN + "?accessToken=" + this.accessToken;
    return _francis.default.get(url).then(function (res) {
      return Promise.resolve(res.data.accessToken);
    }).catch(function (err) {
      return Promise.reject(err);
    });
  };

  _createClass(Auth, [{
    key: "accessToken",
    set: function set(token) {
      var key = this.config.storagePrefix + "access_token";

      _francis.default.setAuthToken(token);

      window.localStorage.setItem(key, token);
    },
    get: function get() {
      var key = this.config.storagePrefix + "access_token";
      return window.localStorage.getItem(key);
    }
  }, {
    key: "refreshToken",
    set: function set(token) {
      var key = this.config.storagePrefix + "refresh_token";
      window.localStorage.setItem(key, token);
    },
    get: function get() {
      var key = this.config.storagePrefix + "refresh_token";
      return window.localStorage.getItem(key);
    }
  }, {
    key: "clientId",
    set: function set(id) {
      var key = this.config.storagePrefix + "client_id";
      window.localStorage.setItem(key, id);
    },
    get: function get() {
      var key = this.config.storagePrefix + "client_id";

      var _clientId = window.localStorage.getItem(key);

      if (!_clientId) {
        _clientId = this._generateClientId();
        this.clientId = _clientId;
      }

      return _clientId;
    }
  }, {
    key: "userId",
    set: function set(userId) {
      var key = this.config.storagePrefix + "user_id";
      window.localStorage.setItem(key, userId);
    },
    get: function get() {
      var key = this.config.storagePrefix + "user_id";
      return window.localStorage.getItem(key);
    }
  }]);

  return Auth;
}();

var _default = Auth;
exports.default = _default;